import { IconButton } from "@material-ui/core";
import React from "react";
import { Col, Row } from "react-bootstrap";
import GetAppIcon from "@material-ui/icons/GetApp";

const DownloadLink = ({ linkName, object, fn }) => {
  return (
    <>
      <Row>
        <Col md="4">
          <IconButton
            variant="contained"
            style={{
              fontSize: "14px",
              cursor: "pointer",
              color: "rgba(46, 46, 46, 1)",
            }}
            onClick={() => {
              fn(object);
            }}
          >
            {linkName}
            <GetAppIcon
              style={{
                color: "rgba(46, 46, 46, 1)",
                cursor: "pointer",
              }}
            />
          </IconButton>
        </Col>
      </Row>
    </>
  );
};

export default DownloadLink;
